<template>
    <li class="pl-24">
        <router-link
            :to="item.to"
            :class="['LeftNavItemChild relative -ml-6 inline-flex items-center rounded-md p-2 hover:bg-slate-50']"
        >
            <span
                :class="{
                    'pointer-events-none -translate-x-3 opacity-0 duration-200': !isExpanded,
                    'pointer-events-auto opacity-100 duration-500': isExpanded,
                }"
                class="title flex w-52 items-center text-sm text-slate-500 transition-all ease-out"
                >{{ item.title }}</span
            >
        </router-link>
    </li>
</template>
<script setup>
defineProps({
    item: {
        type: Object,
        required: true,
    },
    isExpanded: {
        type: Boolean,
        default: false,
    },
})
</script>

<style scoped>
@reference "@/tailwind.css";
.LeftNavItemChild.router-link-active {
    @apply bg-brand-blue-50;
}
.LeftNavItemChild.router-link-active .title {
    @apply text-brand-blue-700;
}
</style>
